// extracted by mini-css-extract-plugin
export default {"card":"FeatureGrid_card__-6L71"};